import * as Common from '@/tenant/common';
import { StockBalanceJournal } from '../Journal/StockBalanceJournal';

export class ChargeItem extends StockBalanceJournal{
  constructor(){
    super('ChargeItem');
    this.binders.charge = new Common.ModelBinder(Common.Charge);
    this.binders.deliveryItem = new Common.ModelBinder(Common.DeliveryItem);
    this.binders.targetStockBalance = new Common.ModelBinder(Common.StockBalance);
  }
  public id: number = 0;
  public chargeItemType: ChargeItemTypes = 0;
  public chargeNo: string = null;
  public charge: Common.Charge  = null;
  public segNo: number = 0;
  public chargeItemNo: string = null;
  public deliveryItemId: string  = null;
  public deliveryItem: Common.DeliveryItem  = null;
  public targetStockBalanceId: number = null;
  public targetStockBalance: Common.StockBalance  = null;

  // 画面表示用項目
  public targetItemNo: string = '';
  public counterpartId: number = 0;
  public displayDateget: string = '';
  public commodityName: string = '';
  public targetAmount: number = 0;
  public counterpart: Common.Counterpart;
  public get packageName(): string{
    if(this.deliveryItem != null && this.deliveryItem.uom != null) return this.deliveryItem.uom.name;
    return this.commodity.getDefaultConversion().name;
  }
  public get linkCharge() {
      if (this.salesPurchaseFlag == Common.SalesPurchaseFlags.Sales) return String.format('/sales/SalesCharge?chargeNo={0}', this.chargeNo);
      else return String.format('/purchase/PurchaseCharge?chargeNo={0}', this.chargeNo);
  }
  public get linkDeliveryItem() {
      if (this.chargeItemType == Common.ChargeItemTypes.Sales) return String.format('/sales/SalesDeliveryItem?deliveryItemNo={0}', this.deliveryItem.deliveryItemNo);
      else if (this.chargeItemType == Common.ChargeItemTypes.Purchase) return String.format('/purchase/PurchaseDeliveryItem?deliveryItemNo={0}', this.deliveryItem.deliveryItemNo);
      else return '';
  } 
  public copy():any {
    const temp = super.copy() as ChargeItem;
    temp.id = 0;
    temp.stockPricing = null;
    temp.stockBalance = null;
    return temp;
  }
}

export enum ChargeItemTypes
{
  Default = 0,
  Sales = 1,
  Purchase = 2, 
  Stock = 3,
}

export class ChargeItemQuery extends Common.LoadQuery {
  constructor(){
        super('ChargeItemQuery',ChargeItem);
        this.loadAll = true;
        this.sort = 'chargeItemNo';
    }
    public chargeNo: string;
    public deliveryItemId :number =null;
    public partialInclude:boolean = false;
} 